import type { SkySpecification } from 'maplibre-gl';

// Sky: dark space with a purple atmospheric limb glow rendered by MapLibre's
// globe atmosphere shader. In globe projection, `atmosphere-blend` enables the
// spherical atmosphere halo — the "horizon" IS the Earth's circular edge, so
// the glow appears uniformly around the entire limb, not just the top.
//
// The globe is deliberately lit evenly: there is no day/night or twilight
// shading, so the basemap and network assets stay readable anywhere on Earth.
//
// Tuning guide:
//   sky-horizon-blend  — glow width/softness (0.2 = tight ring, 0.7 = wide soft halo)
//   horizon-color      — colour of the atmospheric glow
//   atmosphere-blend   — fades the glow as you zoom in (disappears at zoom ≥ 8)
export const GLOBE_SKY: SkySpecification = {
    'sky-color': '#07001a',
    'horizon-color': 'rgba(160, 60, 255, 0.9)',
    'fog-color': '#07001a',
    'fog-ground-blend': 0,
    'horizon-fog-blend': 0,
    'sky-horizon-blend': 0.5,
    'atmosphere-blend': ['interpolate', ['linear'], ['zoom'], 0, 1, 8, 0],
};
